import React, { useState, useEffect } from 'react';
import { Form, Input, Button, Card, Select, Checkbox, Row, Col } from 'antd';
import { Link } from 'react-router-dom';

import { ArrowLeftOutlined } from '@ant-design/icons';

import { toast } from 'react-toastify';
import { CardHeader } from '@material-ui/core';
import api from '~/services/api';
import history from '~/services/history';
import { Container } from './styles';

import CountryList from '~/utils/countriesList';

export default function CustomerNew(params) {
  const [form] = Form.useForm();

  const [residential, setResidential] = useState(false);

  const [customerInfo, setCustomerInfo] = useState(0);
  const [updateFlag, setUpdateFlag] = useState(false);

  const [size, setSize] = useState();
  const [page, setPage] = useState();
  const [query, setQuery] = useState();

  const countryList = CountryList();

  const layout = {
    labelCol: {
      span: 4,
    },
    wrapperCol: {
      span: 14,
    },
  };
  /* eslint-disable no-template-curly-in-string */

  // searchQuery=${searchTxt}&size=${paginationSize}&page=${paginationPage}&totalPages=${paginationTotalItems}

  useEffect(() => {
    async function loadCustomer() {
      const location = new URLSearchParams(params.location.search);
      const customer_id = location.get('id');
      const pageSize = location.get('size');
      const pages = location.get('page');
      const searchQuery = location.get('searchQuery');
      if (customer_id) {
        const customer_info = await api.get(`customers/${customer_id}`);
        const customer = {
          name: customer_info.data.name,
          company: customer_info.data.company,
          email: customer_info.data.email,
          phone: customer_info.data.phone,
          street1: customer_info.data.street1,
          street2: customer_info.data.street2,
          street3: customer_info.data.street3,
          city: customer_info.data.city,
          state: customer_info.data.state,
          country: customer_info.data.country,
          postal_code: customer_info.data.postalCode,
          is_residential: customer_info.data.residential,
        };
        form.setFieldsValue(customer);
        setCustomerInfo(customer_info.data);
        setUpdateFlag(true);
        setSize(pageSize);
        setPage(pages);
        setQuery(searchQuery === 'undefined' ? undefined : searchQuery);
      } else {
        setSize(25);
        setPage(1);
      }
      // setCustomerId(customer_id);
    }
    loadCustomer();
  }, []); // eslint-disable-line

  const onFinish = async values => {
    const newCustomer = {
      name: values.name,
      company: values.company || '',
      email: values.email || '',
      phone: values.phone,
      street1: values.street1,
      street2: values.street2 || '',
      street3: values.street3 || '',
      city: values.city,
      state: values.state,
      country: values.country,
      postal_code: values.postalCode,
      residential,
    };

    try {
      if (updateFlag) {
        await api.put(`customers/${customerInfo.id}`, newCustomer);
        toast.success('Customer Updated.');
      } else {
        await api.post('customers', newCustomer);
        toast.success('New Customer created.');
      }
      history.push('/customers');
    } catch {
      toast.error('Error loading Customer. Contact RBMS administrator.');
    }
  };

  return (
    <Container>
      <Card>
        <Form {...layout} form={form} name="nest-messages" onFinish={onFinish}>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Link to={() => (query === undefined ? `/customers?size=${size}&page=${page}` : `/customers?searchQuery=${query}&size=${size}&page=${page}`)}>
              <Button variant="contained" type="primary" icon={<ArrowLeftOutlined />}>
                Back
              </Button>
            </Link>
            {updateFlag === true ? <CardHeader subheader={`${customerInfo.name}`} title="Update Customer" /> : <CardHeader title="New Customer" />}
            <div />
          </div>
          <Card title="Customer Information" headStyle={{ backgroundColor: 'whitesmoke' }}>
            <Row>
              <Col span={12}>
                <Form.Item
                  name="name"
                  label="Name"
                  rules={[
                    {
                      required: true,
                    },
                  ]}
                >
                  <Input allowClear placeholder="Customer's Name" />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item name="company" label="Company">
                  <Input allowClear placeholder="Company's Name" />
                </Form.Item>
              </Col>
            </Row>
          </Card>
          <Card title="Contact Information" headStyle={{ backgroundColor: 'whitesmoke' }}>
            <Row>
              <Col span={12}>
                <Form.Item name="email" label="Email">
                  <Input allowClear placeholder="Customer's Email" />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="phone"
                  label="Phone"
                  rules={[
                    {
                      required: true,
                    },
                  ]}
                >
                  <Input allowClear placeholder="Customer's Phone Number" />
                </Form.Item>
              </Col>
            </Row>
          </Card>
          <Card title="Delivery Information" headStyle={{ backgroundColor: 'whitesmoke' }}>
            <Row>
              <Col span={12}>
                <Form.Item
                  name="street1"
                  label="Street 1"
                  rules={[
                    {
                      required: true,
                    },
                  ]}
                >
                  <Input allowClear placeholder="Address line 1" />
                </Form.Item>
                <Form.Item name="street2" label="Street 2">
                  <Input allowClear placeholder="Address line 2" />
                </Form.Item>
                <Form.Item name="street3" label="Street 3">
                  <Input allowClear placeholder="Address line 3" />
                </Form.Item>
                <Form.Item
                  name="city"
                  label="City"
                  rules={[
                    {
                      required: true,
                    },
                  ]}
                >
                  <Input allowClear placeholder="Enter the City" />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="state"
                  label="State/Province"
                  rules={[
                    {
                      required: true,
                    },
                  ]}
                >
                  <Input allowClear placeholder="Enter the State or Province" />
                </Form.Item>
                <Form.Item
                  name="country"
                  label="Country"
                  rules={[
                    {
                      required: true,
                    },
                  ]}
                >
                  <Select placeholder="Select a country." options={countryList} showSearch allowClear optionFilterProp="label" />
                </Form.Item>
                <Form.Item
                  name="postalCode"
                  label="Postal Code"
                  rules={[
                    {
                      required: true,
                    },
                  ]}
                >
                  <Input allowClear placeholder="Enter the Postal Code" />
                </Form.Item>
                <Form.Item name="is_residential" wrapperCol={{ ...layout.wrapperCol, offset: 4 }}>
                  <Checkbox checked={residential} onChange={e => setResidential(e.target.checked)}>
                    Is Residential Address
                  </Checkbox>
                </Form.Item>
              </Col>
            </Row>
          </Card>
          <Form.Item wrapperCol={{ ...layout.wrapperCol, offset: 2 }}>
            <Button type="primary" htmlType="submit">
              Save
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </Container>
  );
}
